import React, {
    ReactElement,
} from "react";
import { Dropdown, DropdownDividerProps } from "react-bootstrap";

export type DividerProps = DropdownDividerProps

const Divider = React.forwardRef((
    args: DividerProps,
    ref: React.ForwardedRef<HTMLButtonElement>,
): ReactElement => {
    const {
        ...rest
    } = args;

    return (
        <Dropdown.Divider ref={ref} {...rest} />
    );
});

Divider.defaultProps = {

};

export default Divider;
